import { required } from "vuelidate/lib/validators";

export default class InformacoesData {
  data_inicio = null;
  data_termino = null;
  status = null;
  observacao = "";
  email_fatura = "";
  emitir_nfse = false;
  emitir_boletos = false;
  termino_recorrencia = 1;
  dia_cobranca = 5;
  id_vendedor = null;
  data_venda = null;
  constructor(
    data_inicio = null,
    data_termino = null,
    status = null,
    observacao = "",
    email_fatura = "",
    emitir_nfse = false,
    emitir_boletos = false,
    termino_recorrencia = 1,
    dia_cobranca = 5,
    id_vendedor = null,
    data_venda = null
  ) {
    this.data_inicio = data_inicio;
    this.data_termino = data_termino;
    this.status = status;
    this.observacao = observacao;
    this.email_fatura = email_fatura;
    this.emitir_nfse = emitir_nfse;
    this.emitir_boletos = emitir_boletos;
    this.termino_recorrencia = termino_recorrencia;
    this.dia_cobranca = dia_cobranca;
    this.id_vendedor = id_vendedor;
    this.data_venda = data_venda;
  }
}

export const InformacoesDataRequired = {
  data_inicio: {
    required,
  },
  data_termino: {
    required,
  },
  status: {
    required,
  },
};
